import { render, staticRenderFns } from "./GlobalTemplates.vue?vue&type=template&id=1463440e"
import script from "./GlobalTemplates.vue?vue&type=script&lang=js"
export * from "./GlobalTemplates.vue?vue&type=script&lang=js"
import style0 from "./GlobalTemplates.vue?vue&type=style&index=0&id=1463440e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports